/** Minimal i18n `t` shape used by this helper (avoids coupling tests to TFunction). */
export type TutorBookingChangeTranslateFn = (key: string, defaultValue: string) => string;

type AxiosLikeError = {
  response?: {
    status?: number;
    data?: {
      message?: string;
      error?: string;
    };
  };
};

export function getTutorBookingChangeActionErrorMessage(
  error: unknown,
  t: TutorBookingChangeTranslateFn,
): string {
  const status = (error as AxiosLikeError)?.response?.status;
  const serverMessage = (error as AxiosLikeError)?.response?.data?.message;

  if (status === 403) {
    return t(
      'userTutorBookings.changeProposal.errors.forbidden',
      'You are not allowed to respond to this change proposal.',
    );
  }
  if (status === 404) {
    return t(
      'userTutorBookings.changeProposal.errors.notFound',
      'This change proposal could not be found. Refresh the page and try again.',
    );
  }
  if (status === 409) {
    return (
      serverMessage ||
      t(
        'userTutorBookings.changeProposal.errors.conflict',
        'This change proposal is no longer pending. Refresh the booking for the latest status.',
      )
    );
  }

  return t(
    'userTutorBookings.changeProposal.errors.generic',
    'Something went wrong while updating the change proposal. Please try again.',
  );
}
